// https://stackoverflow.com/questions/196972/convert-string-to-title-case-with-javascript
export const toTitleCase = (str = '') =>
  str
    ? str.replace(
        /\w\S*/g,
        (txt) => txt.slice(0, 1).toUpperCase() + txt.slice(1).toLowerCase()
      )
    : '';
